import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

import { ConfirmPopupStyle } from "./style";

function IgnorePopup(props) {
  const classes = ConfirmPopupStyle();
  const [scroll] = useState("body");
  return (
    <div className={classes.ConfirmWrapper}>
      <Dialog
        open={props.open}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to skip this vehicle? Once confirmed, it will be removed from the list.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            No
          </Button>
          <Button
            onClick={props.handleConfirm}
            color="primary"
            className="orange-btn primary-btn"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default IgnorePopup;
